var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceSite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "service_site_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  clipPath: "url(#service_site_svg__a)",
  "data-name": "Group 88"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 79"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.667 43.296v13.041H28.16V43.296",
  "data-name": "Path 98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.969 56.338v-7.747h4.89v7.747",
  "data-name": "Path 99"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9 46.146 11.414-8.969 11.414 8.969",
  "data-name": "Path 100"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 81"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.029 56.337H28.256V7h25.773z",
  "data-name": "Path 101"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.986 48.973h12.312v7.364H34.986z",
  "data-name": "Rectangle 54"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 80"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.883 45.291v-2.82",
  "data-name": "Line 61"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.51 45.291v-2.82",
  "data-name": "Line 62"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.401 45.291v-2.82",
  "data-name": "Line 63"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.883 37.53v-2.828",
  "data-name": "Line 64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.51 37.53v-2.828",
  "data-name": "Line 65"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.401 37.53v-2.828",
  "data-name": "Line 66"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.883 29.769v-2.828",
  "data-name": "Line 67"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.51 29.769v-2.828",
  "data-name": "Line 68"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.401 29.769v-2.828",
  "data-name": "Line 69"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.883 22.007v-2.828",
  "data-name": "Line 70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.51 22.007v-2.828",
  "data-name": "Line 71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.401 22.007v-2.828",
  "data-name": "Line 72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.883 14.238v-2.82",
  "data-name": "Line 73"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.51 14.238v-2.82",
  "data-name": "Line 74"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.401 14.238v-2.82",
  "data-name": "Line 75"
}))))));
export { SvgServiceSite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBkPSJNMCAwaDY0djY0SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJHcm91cCA4OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMiIgY2xpcC1wYXRoPSJ1cmwoI2EpIj48ZyBkYXRhLW5hbWU9Ikdyb3VwIDc5Ij48cGF0aCBkYXRhLW5hbWU9IlBhdGggOTgiIGQ9Ik0xMi42NjcgNDMuMjk2djEzLjA0MUgyOC4xNlY0My4yOTYiLz48cGF0aCBkYXRhLW5hbWU9IlBhdGggOTkiIGQ9Ik0xNy45NjkgNTYuMzM4di03Ljc0N2g0Ljg5djcuNzQ3Ii8+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDEwMCIgZD0iTTkgNDYuMTQ2bDExLjQxNC04Ljk2OSAxMS40MTQgOC45NjkiLz48L2c+PGcgZGF0YS1uYW1lPSJHcm91cCA4MSI+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDEwMSIgZD0iTTU0LjAyOSA1Ni4zMzdIMjguMjU2VjdoMjUuNzczeiIvPjxwYXRoIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDU0IiBkPSJNMzQuOTg2IDQ4Ljk3M2gxMi4zMTJ2Ny4zNjRIMzQuOTg2eiIvPjxnIGRhdGEtbmFtZT0iR3JvdXAgODAiPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA2MSIgZD0iTTM0Ljg4MyA0NS4yOTF2LTIuODIiLz48cGF0aCBkYXRhLW5hbWU9IkxpbmUgNjIiIGQ9Ik00MS41MSA0NS4yOTF2LTIuODIiLz48cGF0aCBkYXRhLW5hbWU9IkxpbmUgNjMiIGQ9Ik00Ny40MDEgNDUuMjkxdi0yLjgyIi8+PHBhdGggZGF0YS1uYW1lPSJMaW5lIDY0IiBkPSJNMzQuODgzIDM3LjUzdi0yLjgyOCIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA2NSIgZD0iTTQxLjUxIDM3LjUzdi0yLjgyOCIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA2NiIgZD0iTTQ3LjQwMSAzNy41M3YtMi44MjgiLz48cGF0aCBkYXRhLW5hbWU9IkxpbmUgNjciIGQ9Ik0zNC44ODMgMjkuNzY5di0yLjgyOCIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA2OCIgZD0iTTQxLjUxIDI5Ljc2OXYtMi44MjgiLz48cGF0aCBkYXRhLW5hbWU9IkxpbmUgNjkiIGQ9Ik00Ny40MDEgMjkuNzY5di0yLjgyOCIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA3MCIgZD0iTTM0Ljg4MyAyMi4wMDd2LTIuODI4Ii8+PHBhdGggZGF0YS1uYW1lPSJMaW5lIDcxIiBkPSJNNDEuNTEgMjIuMDA3di0yLjgyOCIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA3MiIgZD0iTTQ3LjQwMSAyMi4wMDd2LTIuODI4Ii8+PHBhdGggZGF0YS1uYW1lPSJMaW5lIDczIiBkPSJNMzQuODgzIDE0LjIzOHYtMi44MiIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA3NCIgZD0iTTQxLjUxIDE0LjIzOHYtMi44MiIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA3NSIgZD0iTTQ3LjQwMSAxNC4yMzh2LTIuODIiLz48L2c+PC9nPjwvZz48L3N2Zz4=";